/** The local storage key for the target to forward to after login */

export const TARGET_PATH = 'tunasong.auth.targetPath'
